export const featuredProducts = [
  {
    id: 1,
    name: 'Camiseta Camimera',
    description: 'Camiseta 100% algodón de alta calidad. Perfecta para personalización.',
    price: 2.45,
    image: 'https://public.readdy.ai/ai/img_res/19604a1972f178f71768917fb087d2cf.jpg',
    category: 'Camisetas',
    colors: ['Plomo', 'Amarillo', 'Naranja', 'Lima', 'Blanco'],
    sizes: ['S', 'M', 'L', 'XL'],
    stock: 500,
    featured: true,
    unitPrice: 2.45,
    minQuantity: 1
  },
  {
    id: 2,
    name: 'Polo Básico Premium',
    description: 'Polo de algodón piqué con cuello y botones. Ideal para uniformes empresariales.',
    price: 9.00,
    image: 'https://readdy.ai/api/search-image?query=premium%20polo%20shirt%20cotton%20pique%20fabric%20on%20white%20background%20professional%20product%20shot%20clean%20studio%20lighting%20business%20casual%20style%20folded%20presentation&width=400&height=400&seq=polo002&orientation=squarish',
    category: 'Polos',
    colors: ['Negro', 'Blanco', 'Azul Marino', 'Gris', 'Rojo'],
    sizes: ['S', 'M', 'L', 'XL'],
    stock: 300,
    featured: true,
    unitPrice: 9.00,
    minQuantity: 10
  },
  {
    id: 3,
    name: 'Chaqueta Softshell Antártida',
    description: 'Chaqueta técnica cortavientos e impermeable. Perfecta para invierno.',
    price: 35.00,
    image: 'https://readdy.ai/api/search-image?query=technical%20softshell%20jacket%20waterproof%20windbreaker%20on%20clean%20white%20background%20professional%20product%20photography%20outdoor%20sportswear%20modern%20design%20studio%20shot&width=400&height=400&seq=antartida003&orientation=squarish',
    category: 'Chaquetas',
    colors: ['Negro', 'Azul Marino', 'Gris Oscuro', 'Rojo'],
    sizes: ['S', 'M', 'L', 'XL'],
    stock: 150,
    featured: true,
    highlight: true,
    unitPrice: 35.00,
    minQuantity: 10
  },
  {
    id: 4,
    name: 'Sudadera Roly',
    description: 'Sudadera de felpa con capucha. Cómoda y resistente para uso diario.',
    price: 14.50,
    image: 'https://readdy.ai/api/search-image?query=comfortable%20hoodie%20sweatshirt%20fleece%20fabric%20on%20white%20background%20casual%20wear%20product%20photography%20clean%20studio%20lighting%20modern%20streetwear%20style&width=400&height=400&seq=sudadera004&orientation=squarish',
    category: 'Sudaderas',
    colors: ['Negro', 'Gris', 'Azul Marino', 'Blanco', 'Rojo'],
    sizes: ['S', 'M', 'L', 'XL'],
    stock: 200,
    featured: true,
    unitPrice: 14.50,
    minQuantity: 10
  },
  {
    id: 5,
    name: 'Chaleco Oslo Masculino',
    description: 'Chaleco acolchado ligero y cálido. Perfecto para entretiempo.',
    price: 25.00,
    image: 'https://readdy.ai/api/search-image?query=mens%20quilted%20vest%20padded%20gilet%20lightweight%20on%20white%20background%20professional%20product%20shot%20outdoor%20clothing%20clean%20studio%20style%20modern%20design&width=400&height=400&seq=oslo005&orientation=squarish',
    category: 'Chalecos',
    colors: ['Negro', 'Azul Marino', 'Gris', 'Verde Oliva'],
    sizes: ['S', 'M', 'L', 'XL'],
    stock: 100,
    featured: true,
    unitPrice: 25.00,
    minQuantity: 5
  },
  {
    id: 6,
    name: 'Chaleco Oslo Femenino',
    description: 'Chaleco acolchado diseño femenino. Ligero y elegante.',
    price: 25.00,
    image: 'https://readdy.ai/api/search-image?query=womens%20quilted%20vest%20padded%20gilet%20feminine%20fit%20on%20white%20background%20professional%20product%20photography%20outdoor%20fashion%20clean%20studio%20lighting%20elegant%20style&width=400&height=400&seq=oslofem006&orientation=squarish',
    category: 'Chalecos',
    colors: ['Negro', 'Azul Marino', 'Gris', 'Burdeos'],
    sizes: ['S', 'M', 'L', 'XL'],
    stock: 100,
    featured: true,
    unitPrice: 25.00,
    minQuantity: 5
  }
];

// Export products array for catalog page
export const products = featuredProducts;

export const packs = [
  {
    id: 101,
    name: 'Pack Camisetas Camimera x100',
    description: 'Pack de 100 camisetas Camimera 100% algodón. Colores: Plomo, Amarillo, Naranja, Lima y Blanco. Tallas S a XL disponibles.',
    price: 245.00,
    originalPrice: 300.00,
    savings: 55.00,
    regularPrice: 300.00,
    packPrice: 245.00,
    totalItems: 100,
    image: 'https://readdy.ai/api/search-image?query=stack%20of%20colorful%20cotton%20t-shirts%20folded%20neatly%20on%20white%20background%20bulk%20wholesale%20clothing%20professional%20product%20photography%20vibrant%20colors%20yellow%20orange%20lime%20white%20grey&width=600&height=400&seq=pack101&orientation=landscape',
    category: 'packs',
    items: [
      { product: 'Camiseta Camimera', quantity: 100, colors: ['Plomo', 'Amarillo', 'Naranja', 'Lima', 'Blanco'], sizes: ['S', 'M', 'L', 'XL'], name: 'Camiseta Camimera', productId: 1 }
    ],
    featured: true,
    stock: 50,
    freeShipping: true
  },
  {
    id: 102,
    name: 'Pack Polos Premium x10',
    description: 'Pack de 10 polos de algodón piqué. Varios colores disponibles. Ideal para uniformes.',
    price: 85.00,
    originalPrice: 100.00,
    savings: 15.00,
    regularPrice: 100.00,
    packPrice: 85.00,
    totalItems: 10,
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20premium%20polo%20shirts%20stacked%20together%20on%20white%20background%20business%20casual%20wear%20wholesale%20pack%20professional%20photography%20multiple%20colors%20clean%20presentation&width=600&height=400&seq=pack102&orientation=landscape',
    category: 'packs',
    items: [
      { product: 'Polo Básico Premium', quantity: 10, colors: ['Negro', 'Blanco', 'Azul Marino', 'Gris', 'Rojo'], sizes: ['S', 'M', 'L', 'XL'], name: 'Polo Básico Premium', productId: 2 }
    ],
    featured: true,
    stock: 40,
    freeShipping: true
  },
  {
    id: 103,
    name: 'OFERTA: Pack Chaquetas Antártida x10',
    description: 'Pack especial de 10 chaquetas Softshell Antártida. Cortavientos e impermeables. ¡Oferta limitada!',
    price: 295.00,
    originalPrice: 350.00,
    savings: 55.00,
    regularPrice: 350.00,
    packPrice: 295.00,
    totalItems: 10,
    image: 'https://readdy.ai/api/search-image?query=group%20of%20technical%20softshell%20jackets%20outdoor%20wear%20on%20white%20background%20wholesale%20bundle%20professional%20product%20shot%20waterproof%20clothing%20modern%20design%20clean%20studio&width=600&height=400&seq=pack103&orientation=landscape',
    category: 'packs',
    items: [
      { product: 'Chaqueta Softshell Antártida', quantity: 10, colors: ['Negro', 'Azul Marino', 'Gris Oscuro', 'Rojo'], sizes: ['S', 'M', 'L', 'XL'], name: 'Chaqueta Softshell Antártida', productId: 3 }
    ],
    featured: true,
    highlight: true,
    stock: 25,
    limitedStock: 25,
    offerStart: '2025-02-01',
    offerEnd: '2025-02-28',
    freeShipping: true
  },
  {
    id: 104,
    name: 'Pack Sudaderas Roly x10',
    description: 'Pack de 10 sudaderas con capucha de felpa. Perfectas para el día a día.',
    price: 145.00,
    originalPrice: 170.00,
    savings: 25.00,
    regularPrice: 170.00,
    packPrice: 145.00,
    totalItems: 10,
    image: 'https://readdy.ai/api/search-image?query=stack%20of%20hooded%20sweatshirts%20casual%20wear%20on%20white%20background%20wholesale%20clothing%20bundle%20professional%20photography%20comfortable%20hoodies%20multiple%20colors%20clean%20display&width=600&height=400&seq=pack104&orientation=landscape',
    category: 'packs',
    items: [
      { product: 'Sudadera Roly', quantity: 10, colors: ['Negro', 'Gris', 'Azul Marino', 'Blanco', 'Rojo'], sizes: ['S', 'M', 'L', 'XL'], name: 'Sudadera Roly', productId: 4 }
    ],
    featured: true,
    stock: 30,
    freeShipping: true
  },
  {
    id: 105,
    name: 'Pack Chalecos Oslo x5',
    description: 'Pack de 5 chalecos Oslo (masculino y femenino). Ligeros y cálidos para entretiempo.',
    price: 125.00,
    originalPrice: 145.00,
    savings: 20.00,
    regularPrice: 145.00,
    packPrice: 125.00,
    totalItems: 5,
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20quilted%20vests%20padded%20gilets%20on%20white%20background%20outdoor%20clothing%20wholesale%20pack%20professional%20product%20photography%20modern%20style%20clean%20studio%20shot&width=600&height=400&seq=pack105&orientation=landscape',
    category: 'packs',
    items: [
      { product: 'Chaleco Oslo', quantity: 5, colors: ['Negro', 'Azul Marino', 'Gris', 'Verde Oliva', 'Burdeos'], sizes: ['S', 'M', 'L', 'XL'], name: 'Chaleco Oslo', productId: 5 }
    ],
    featured: true,
    stock: 35,
    freeShipping: true
  },
  {
    id: 106,
    name: 'Pack Starter Empresas x10',
    description: 'Pack inicial perfecto para empresas. Incluye 10 prendas variadas con envío gratuito.',
    price: 445.00,
    originalPrice: 520.00,
    savings: 75.00,
    regularPrice: 520.00,
    packPrice: 445.00,
    totalItems: 10,
    image: 'https://readdy.ai/api/search-image?query=assorted%20business%20clothing%20bundle%20corporate%20wear%20on%20white%20background%20wholesale%20starter%20pack%20professional%20photography%20mixed%20garments%20clean%20presentation%20modern%20style&width=600&height=400&seq=pack106&orientation=landscape',
    category: 'packs',
    items: [
      { product: 'Camiseta Camimera', quantity: 3, colors: ['Plomo', 'Amarillo', 'Naranja', 'Lima', 'Blanco'], sizes: ['S', 'M', 'L', 'XL'], name: 'Camiseta Camimera', productId: 1 },
      { product: 'Polo Básico Premium', quantity: 3, colors: ['Negro', 'Blanco', 'Azul Marino'], sizes: ['S', 'M', 'L', 'XL'], name: 'Polo Básico Premium', productId: 2 },
      { product: 'Sudadera Roly', quantity: 2, colors: ['Negro', 'Gris', 'Azul Marino'], sizes: ['S', 'M', 'L', 'XL'], name: 'Sudadera Roly', productId: 4 },
      { product: 'Chaqueta Softshell Antártida', quantity: 2, colors: ['Negro', 'Azul Marino'], sizes: ['S', 'M', 'L', 'XL'], name: 'Chaqueta Softshell Antártida', productId: 3 }
    ],
    featured: true,
    stock: 20,
    freeShipping: true
  }
];

export const categories = [
  {
    id: 'camisetas',
    name: 'Camisetas',
    description: 'Camisetas de algodón para personalización',
    image: 'https://readdy.ai/api/search-image?query=variety%20of%20plain%20cotton%20t-shirts%20different%20colors%20on%20white%20background%20clothing%20category%20professional%20product%20photography%20clean%20minimal%20style%20wholesale%20apparel&width=400&height=300&seq=cat001&orientation=landscape',
    count: 150
  },
  {
    id: 'polos',
    name: 'Polos',
    description: 'Polos de calidad para uso profesional',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20polo%20shirts%20business%20casual%20wear%20on%20white%20background%20clothing%20category%20professional%20photography%20clean%20studio%20style%20corporate%20apparel&width=400&height=300&seq=cat002&orientation=landscape',
    count: 80
  },
  {
    id: 'chaquetas',
    name: 'Chaquetas',
    description: 'Chaquetas técnicas y softshell',
    image: 'https://readdy.ai/api/search-image?query=technical%20jackets%20outdoor%20wear%20collection%20on%20white%20background%20clothing%20category%20professional%20product%20shot%20sportswear%20modern%20design%20clean%20display&width=400&height=300&seq=cat003&orientation=landscape',
    count: 45
  },
  {
    id: 'sudaderas',
    name: 'Sudaderas',
    description: 'Sudaderas con y sin capucha',
    image: 'https://readdy.ai/api/search-image?query=variety%20of%20sweatshirts%20and%20hoodies%20casual%20wear%20on%20white%20background%20clothing%20category%20professional%20photography%20comfortable%20apparel%20clean%20studio%20style&width=400&height=300&seq=cat004&orientation=landscape',
    count: 60
  },
  {
    id: 'chalecos',
    name: 'Chalecos',
    description: 'Chalecos acolchados para entretiempo',
    image: 'https://readdy.ai/api/search-image?query=quilted%20vests%20collection%20padded%20gilets%20on%20white%20background%20clothing%20category%20professional%20product%20photography%20outdoor%20wear%20clean%20minimal%20display&width=400&height=300&seq=cat005&orientation=landscape',
    count: 35
  },
  {
    id: 'packs',
    name: 'Packs Especiales',
    description: 'Packs con descuentos exclusivos',
    image: 'https://readdy.ai/api/search-image?query=wholesale%20clothing%20bundles%20special%20packs%20on%20white%20background%20bulk%20apparel%20professional%20photography%20discount%20deals%20clean%20presentation%20modern%20style&width=400&height=300&seq=cat006&orientation=landscape',
    count: 15
  }
];

export const sizeGuide = {
  'S': { chest: '88-92 cm', waist: '76-80 cm', hips: '92-96 cm' },
  'M': { chest: '96-100 cm', waist: '84-88 cm', hips: '100-104 cm' },
  'L': { chest: '104-108 cm', waist: '92-96 cm', hips: '108-112 cm' },
  'XL': { chest: '112-116 cm', waist: '100-104 cm', hips: '116-120 cm' }
};
